import {
    Box,
    Button,
    Grid,
    Menu,
    MenuItem,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React, { useEffect } from 'react';
import Filter from './filter';
import PieChart from './charts/pie-chart';
import imageGender from 'assets/images/icons/campaign-data-analytics/gender.png';
import PercentChart from './charts/percent-chart';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RegionChart from './charts/region-chart';
import { createStyleSheet, handleError } from 'utils/helpers';
import QuestionLineChart from './charts/question-line-chart';
import QuestionStackedColumnChart from './charts/question-stacked-column-chart';
import QuestionRadarChart from './charts/question-radar-chart';
import QuestionPieChart from './charts/question-pie-chart';
import { ReactComponent as ChartBarHorizontal } from 'assets/images/icons/campaign-data-analytics/chart bar ngang.svg';
import { ReactComponent as ChartBarHorizontalActive } from 'assets/images/icons/campaign-data-analytics/chart bar ngang active.svg';
import { ReactComponent as ChartBarVertical } from 'assets/images/icons/campaign-data-analytics/bar chart dọc.svg';
import { ReactComponent as ChartBarVerticalActive } from 'assets/images/icons/campaign-data-analytics/bar chart dọc active.svg';
import { ReactComponent as ChartStackedBarHorizontal } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng.svg';
import { ReactComponent as ChartStackedBarHorizontalActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng active.svg';
import { ReactComponent as ChartStackedBarVertical } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng dọc.svg';
import { ReactComponent as ChartStackedBarVerticalActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng dọc active.svg';
import { ReactComponent as ChartPie } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn.svg';
import { ReactComponent as ChartPieActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn active.svg';
import { ReactComponent as ChartDonut } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn donut.svg';
import { ReactComponent as ChartDonutActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn donut active.svg';
import { ReactComponent as ChartLineSingle } from 'assets/images/icons/campaign-data-analytics/biểu đồ đường đơn.svg';
import { ReactComponent as ChartLineSingleActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ đường đơn active.svg';
import { ReactComponent as ChartLineMulti } from 'assets/images/icons/campaign-data-analytics/biểu đồ multi line.svg';
import { ReactComponent as ChartLineMultiActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ multi line active.svg';
import { ReactComponent as ChartHeatMap } from 'assets/images/icons/campaign-data-analytics/biểu đồ heat map.svg';
import { ReactComponent as ChartHeatMapActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ heat map active.svg';
import { ReactComponent as ChartRadar } from 'assets/images/icons/campaign-data-analytics/biểu đồ radar.svg';
import { ReactComponent as ChartRadarActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ radar active.svg';
import QuestionBarChart from './charts/question-bar-chart';
import QuestionHeatMapChart from './charts/question-heat-chart';
import Compare from './compare';
import Display from './display';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { selectChartSummaryProfileColors } from 'common/theme-selectors';
import { RootState } from 'plugins/store';
import { IDisplay, setDisplay } from 'slices/dataAnalyticsDisplaySlice';
import { savePDF } from '@progress/kendo-react-pdf';
import { DisplayType } from '../constants';
import { getCampaignDataStatisticsSummary } from 'services/campaign.service';
import { useParams } from 'react-router-dom';
import { ICampaignDataStatisticsSummaryResponse } from 'types/campaign';
import { QuestionType } from 'pages/admin/campaign-overview/constants';
import { setListQuestionDataFilter } from 'slices/questionSummarySlice';
import TableDataAnalytics from './table-data';
import { useTranslation } from 'react-i18next';
import CompareResult from './compare-result';
import QuestionTextFilterResult from './question-text-table';
import QuestionTableDetail from './question-table-detail';
import ModalExportExcelTurbulation from './modal-export-excel-turbulation';

type TypeTab = 'filter' | 'compare' | 'display';

export const listChartType = [
    {
        value: 'bartChartHorizontal',
        icon: <ChartBarHorizontal />,
        iconActive: <ChartBarHorizontalActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'bartChartVertical',
        icon: <ChartBarVertical />,
        iconActive: <ChartBarVerticalActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartStackedBarHorizontal',
        icon: <ChartStackedBarHorizontal />,
        iconActive: <ChartStackedBarHorizontalActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Emoji,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartStackedBarVertical',
        icon: <ChartStackedBarVertical />,
        iconActive: <ChartStackedBarVerticalActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Emoji,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartPie',
        icon: <ChartPie />,
        iconActive: <ChartPieActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartDonut',
        icon: <ChartDonut />,
        iconActive: <ChartDonutActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Dropdown,
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Rank,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartLineSingle',
        icon: <ChartLineSingle />,
        iconActive: <ChartLineSingleActive />,
        acceptType: [
            QuestionType.SingleChoice,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.Checkbox,
            QuestionType.Score,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Dropdown,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartLineMulti',
        icon: <ChartLineMulti />,
        iconActive: <ChartLineMultiActive />,
        acceptType: [
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Rank,
            // QuestionType.Score,
            // QuestionType.Checkbox,
            // QuestionType.SingleChoice,
            QuestionType.Rank,
            // QuestionType.Dropdown,
            // QuestionType.TextboxRecommend,
            // QuestionType.TextboxRecommendMultiChoice,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartHeatMap',
        icon: <ChartHeatMap />,
        iconActive: <ChartHeatMapActive />,
        acceptType: [
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.SliderScale,
            QuestionType.Rank,
            QuestionType.Date,
            QuestionType.SliderScale,
        ],
    },
    {
        value: 'chartRadar',
        icon: <ChartRadar />,
        iconActive: <ChartRadarActive />,
        acceptType: [
            QuestionType.MatrixCheckbox,
            QuestionType.MatrixRadio,
            QuestionType.Emoji,
            QuestionType.ScoreStarFull,
            QuestionType.ScoreStarHalf,
            QuestionType.Rank,
            QuestionType.Score,
            QuestionType.Checkbox,
            QuestionType.SingleChoice,
            QuestionType.Rank,
            QuestionType.Dropdown,
            QuestionType.TextboxRecommend,
            QuestionType.TextboxRecommendMultiChoice,
            QuestionType.SliderScale,
            // QuestionType.Date,
        ],
    },
];

const Summary: React.FC = () => {
    const { t } = useTranslation();
    const campaignId = useParams<{ id: string }>().id;
    const container = React.useRef(null);
    const dispatch = useAppDispatch();
    const dataDisplay = useAppSelector(
        (state: RootState) => state.dataAnalyticsDisplay.display
    );
    const [
        openModalExportExcelTurbulation,
        setOpenModalExportExcelTurbulation,
    ] = React.useState<boolean>(false);

    const [tabActive, setTabActive] = React.useState<TypeTab>('filter');
    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );
    const profileColors = useAppSelector(selectChartSummaryProfileColors);

    const handleChangeTab = (
        event: React.SyntheticEvent,
        newValue: TypeTab
    ) => {
        if (newValue !== 'display') {
            dispatch(
                setDisplay({ displayType: [], questions: [], decimal: '' })
            );
        }
        dispatch(setListQuestionDataFilter([]));
        setTabActive(newValue);
    };
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const exportPDFWithMethod = () => {
        const element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 40,
            fileName: currentCampaign?.campaign,
        });
    };

    const [campaignSummaryData, setCampaignSummaryData] =
        React.useState<ICampaignDataStatisticsSummaryResponse>();
    useEffect(() => {
        const fetDataSummary = async () => {
            try {
                const response = await getCampaignDataStatisticsSummary(
                    Number(campaignId)
                );
                if (response.success) {
                    setCampaignSummaryData(response.data);
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetDataSummary();
    }, [campaignId]);

    const listQuestionsDataFilter = useAppSelector(
        (state: RootState) => state.questionDataFilter
    );
    const [chartActive, setChartActive] = React.useState<
        Record<number, string>
    >({});
    useEffect(() => {
        if ((listQuestionsDataFilter || []).length > 0) {
            const defaultState: Record<number, string> = {};
            listQuestionsDataFilter?.forEach((q, index) => {
                defaultState[index] = 'bartChartHorizontal';
            });
            setChartActive(defaultState);
        }
    }, [listQuestionsDataFilter, tabActive]);

    const handleTabChartChange = (questionId: number, newValue: string) => {
        setChartActive((prev) => ({
            ...prev,
            [questionId]: newValue,
        }));
    };
    useEffect(() => {
        dispatch(setListQuestionDataFilter([]));
        // eslint-disable-next-line
    }, [window.location, dispatch]); // do not remove window.location from dependencies
    const shouldShowGraph = (tabActive: string, dataDisplay: IDisplay) => {
        return (
            tabActive === 'filter' ||
            dataDisplay.displayType.includes(DisplayType.GRAPH) ||
            (tabActive === 'display' &&
                dataDisplay.displayType.includes(DisplayType.GRAPH))
        );
    };

    const shouldShowTableData = (tabActive: string, dataDisplay: IDisplay) => {
        return (
            tabActive === 'filter' ||
            dataDisplay.displayType.includes(DisplayType.DATA_TABLE) ||
            (tabActive === 'display' &&
                dataDisplay.displayType.includes(DisplayType.DATA_TABLE))
        );
    };
    return (
        <Box>
            <Grid
                container
                spacing={2}
                alignItems={'baseline'}
                sx={{
                    mt: 3,
                    mb: 1,
                }}
            >
                <Grid item xs={12} md={3}>
                    <Typography
                        sx={{
                            color: colors.main,
                            fontSize: '28px',
                            fontWeight: 700,
                        }}
                    >
                        Công cụ phân tích
                    </Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Typography
                        sx={{
                            color: colors.main,
                            fontSize: '28px',
                            fontWeight: 700,
                        }}
                    >
                        {currentCampaign?.campaign}
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Button
                        sx={{
                            textTransform: 'none',
                            minWidth: '177px',
                            height: '60px',
                            borderRadius: '39px',
                            padding: '0px',
                        }}
                        id="basic-button"
                        variant="contained"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        endIcon={
                            <ExpandMoreIcon
                                sx={{
                                    width: 40,
                                    height: 40,
                                }}
                            />
                        }
                        startIcon={
                            <FileDownloadOutlinedIcon
                                sx={{
                                    fontSize: '40px !important',
                                    color: 'inherit',
                                }}
                            />
                        }
                    >
                        <Typography
                            fontSize={20}
                            component={'span'}
                            fontWeight={'bold'}
                            lineHeight={'24px'}
                        >
                            {t('page.campaign.button.export')}
                        </Typography>
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        sx={{
                            '& .MuiPaper-root': {
                                borderRadius: '7px',
                                marginTop: '10px',
                                minWidth: '177px',
                            },
                        }}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem
                            className="navigate-button"
                            onClick={() => {
                                handleClose();
                                // toast.warning(
                                //     'Hệ thống chưa hỗ trợ, vui lòng thử lại sau'
                                // );
                                setOpenModalExportExcelTurbulation(true);
                            }}
                        >
                            Xuất Excel
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleClose();
                                exportPDFWithMethod();
                            }}
                        >
                            Xuất PDF
                        </MenuItem>
                    </Menu>
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12} md={3}>
                    <Box
                        sx={{
                            borderRadius: '15px',
                            height: '100%',
                            overflow: 'auto',
                            backgroundColor: common.white,
                        }}
                    >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                                value={tabActive}
                                onChange={handleChangeTab}
                                aria-label="basic tabs example"
                                sx={{
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontWeight: '700',
                                        fontSize: '24px',
                                        padding: 2,
                                    },
                                    '& .MuiTabs-flexContainer': {
                                        justifyContent: 'space-between',
                                    },
                                    '& .Mui-selected': {
                                        fontWeight: '700',
                                        borderRadius: '50px',
                                        color: colors.main,
                                    },
                                    '& .MuiTabs-indicator	 ': {
                                        border: `2px solid ${colors.main}`,
                                    },
                                }}
                            >
                                <Tab value={'filter'} label={'Lọc'} />
                                <Tab value={'compare'} label={'So sánh'} />
                                <Tab value={'display'} label={'Hiển thị'} />
                            </Tabs>
                        </Box>
                        {tabActive === 'filter' && (
                            <Box p={2}>
                                <Filter />
                            </Box>
                        )}
                        {tabActive === 'compare' && (
                            <Box p={2}>
                                <Compare />
                            </Box>
                        )}
                        {tabActive === 'display' && (
                            <Box p={2}>
                                <Display />
                            </Box>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12} md={9} ref={container}>
                    <Box
                        sx={{
                            borderRadius: '15px',
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                justifyContent: 'space-between',
                                mb: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 3,
                                }}
                            >
                                <PieChart
                                    title={
                                        campaignSummaryData?.userProfile.name ??
                                        ''
                                    }
                                    colors={profileColors.userProfile}
                                    data={
                                        campaignSummaryData?.userProfile.data ??
                                        []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 3,
                                }}
                            >
                                <PieChart
                                    title={
                                        campaignSummaryData?.gender.name ?? ''
                                    }
                                    imageUrl={imageGender}
                                    colors={profileColors.gender}
                                    data={
                                        campaignSummaryData?.gender.data ?? []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 3,
                                }}
                            >
                                <PieChart
                                    title={
                                        campaignSummaryData?.marriage?.name ??
                                        ''
                                    }
                                    colors={profileColors.marriage}
                                    data={
                                        campaignSummaryData?.marriage.data ?? []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 3,
                                }}
                            >
                                <PieChart
                                    title={
                                        campaignSummaryData?.children?.name ??
                                        ''
                                    }
                                    colors={profileColors.children}
                                    data={
                                        campaignSummaryData?.children?.data ??
                                        []
                                    }
                                />
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                }}
                            >
                                <PercentChart
                                    title={campaignSummaryData?.job.name ?? ''}
                                    data={campaignSummaryData?.job.data ?? []}
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                }}
                            >
                                <PercentChart
                                    title={
                                        campaignSummaryData?.career?.name ?? ''
                                    }
                                    data={
                                        campaignSummaryData?.career?.data ?? []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                    maxHeight: '500px',
                                }}
                            >
                                <RegionChart
                                    title={
                                        campaignSummaryData?.region?.name ?? ''
                                    }
                                    data={
                                        campaignSummaryData?.region?.data ?? []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                }}
                            >
                                <PercentChart
                                    title={
                                        campaignSummaryData
                                            ?.monthly_personal_income?.name ??
                                        ''
                                    }
                                    data={
                                        campaignSummaryData
                                            ?.monthly_personal_income?.data ??
                                        []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                }}
                            >
                                <PercentChart
                                    title={
                                        campaignSummaryData
                                            ?.monthly_family_income?.name ?? ''
                                    }
                                    data={
                                        campaignSummaryData
                                            ?.monthly_family_income?.data ?? []
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    flex: '1 1 calc(33.33% - 16px)',
                                    backgroundColor: common.white,
                                    borderRadius: '30px',
                                    p: 4,
                                }}
                            >
                                <PercentChart
                                    title={campaignSummaryData?.age?.name ?? ''}
                                    data={campaignSummaryData?.age?.data ?? []}
                                />
                            </Box>
                        </Box>
                        {listQuestionsDataFilter.length > 0 && (
                            <>
                                {(tabActive === 'filter' ||
                                    tabActive === 'display') && (
                                    <>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: '28px',
                                                fontWeight: 'bold',
                                                color: colors.main,
                                            }}
                                            mt={3}
                                            mb={3}
                                        >
                                            {tabActive === 'filter'
                                                ? 'Kết quả lọc'
                                                : 'Dữ liệu hiển thị'}
                                        </Typography>
                                        <Box
                                            mt={2}
                                            sx={{
                                                backgroundColor: common.white,
                                                borderRadius: '30px',
                                                p: 3,
                                            }}
                                        >
                                            {listQuestionsDataFilter?.map(
                                                (question, index) => {
                                                    return (
                                                        <Box
                                                            key={
                                                                question.question_id
                                                            }
                                                        >
                                                            <Box>
                                                                <Typography
                                                                    variant="h5"
                                                                    sx={{
                                                                        mt: 2,
                                                                        fontWeight: 700,
                                                                        fontSize:
                                                                            '24px',
                                                                        lineHeight:
                                                                            '33.89px',
                                                                    }}
                                                                >
                                                                    Câu{' '}
                                                                    {
                                                                        question.question_number
                                                                    }
                                                                    :{' '}
                                                                    {
                                                                        question.question_title
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            {(dataDisplay.displayType.includes(
                                                                'GRAPH'
                                                            ) ||
                                                                tabActive ===
                                                                    'filter' ||
                                                                tabActive ===
                                                                    'display') && (
                                                                <>
                                                                    <Box
                                                                        sx={{
                                                                            display:
                                                                                'flex',
                                                                            justifyContent:
                                                                                'flex-end',
                                                                        }}
                                                                        mt={2}
                                                                    >
                                                                        <Tabs
                                                                            TabIndicatorProps={{
                                                                                style: {
                                                                                    display:
                                                                                        'none',
                                                                                },
                                                                            }}
                                                                            value={
                                                                                chartActive[
                                                                                    index
                                                                                ] ??
                                                                                'bartChartHorizontal'
                                                                            }
                                                                            onChange={(
                                                                                _,
                                                                                newValue
                                                                            ) =>
                                                                                handleTabChartChange(
                                                                                    index,
                                                                                    newValue
                                                                                )
                                                                            }
                                                                            aria-label="wrapped label tabs example"
                                                                            sx={{
                                                                                '& .MuiTabs-flexContainer':
                                                                                    {
                                                                                        gap: 1,
                                                                                    },
                                                                            }}
                                                                        >
                                                                            {listChartType
                                                                                .filter(
                                                                                    (
                                                                                        item
                                                                                    ) =>
                                                                                        item.acceptType?.includes(
                                                                                            question.question_type as QuestionType
                                                                                        )
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        item
                                                                                    ) => (
                                                                                        <Tab
                                                                                            key={
                                                                                                item.value
                                                                                            }
                                                                                            value={
                                                                                                item.value
                                                                                            }
                                                                                            icon={
                                                                                                chartActive[
                                                                                                    index
                                                                                                ] ===
                                                                                                item.value
                                                                                                    ? item.iconActive
                                                                                                    : item.icon
                                                                                            }
                                                                                            sx={{
                                                                                                ...styles.tab,
                                                                                                '&.Mui-selected':
                                                                                                    {
                                                                                                        backgroundColor:
                                                                                                            'primary.main',
                                                                                                    },
                                                                                            }}
                                                                                        />
                                                                                    )
                                                                                )}
                                                                        </Tabs>
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            mt: 2,
                                                                            p: 2,
                                                                            border: '1px solid #ddd',
                                                                            borderRadius:
                                                                                '8px',
                                                                        }}
                                                                    >
                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'bartChartHorizontal'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionBarChart
                                                                                              orientation="horizontal"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'bartChartVertical'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionBarChart
                                                                                              orientation="vertical"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}
                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartLineMulti'
                                                                            ? [
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Rank,
                                                                                  //   QuestionType.Score,
                                                                                  //   QuestionType.Checkbox,
                                                                                  //   QuestionType.SingleChoice,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  //   QuestionType.Dropdown,
                                                                                  //   QuestionType.TextboxRecommend,
                                                                                  //   QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionLineChart
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              dataMulple={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.rada_chart ??
                                                                                                  []
                                                                                              }
                                                                                              isMultiple={
                                                                                                  true
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartLineSingle'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionLineChart
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                              isMultiple={
                                                                                                  false
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartPie'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionPieChart
                                                                                              type="pie"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}
                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartDonut'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionPieChart
                                                                                              type="donut"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartStackedBarHorizontal'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionStackedColumnChart
                                                                                              type="horizontal"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartStackedBarVertical'
                                                                            ? [
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionStackedColumnChart
                                                                                              type="vertical"
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.chart_number
                                                                                                      ?.data ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartHeatMap'
                                                                            ? [
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.SliderScale,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.Date,
                                                                                  QuestionType.SliderScale,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionHeatMapChart
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              info={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.heat_chart ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}
                                                                        {chartActive[
                                                                            index
                                                                        ] ===
                                                                        'chartRadar'
                                                                            ? [
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.Emoji,
                                                                                  QuestionType.ScoreStarFull,
                                                                                  QuestionType.ScoreStarHalf,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.Score,
                                                                                  QuestionType.Checkbox,
                                                                                  QuestionType.SingleChoice,
                                                                                  QuestionType.Rank,
                                                                                  QuestionType.MatrixRadio,
                                                                                  QuestionType.MatrixCheckbox,
                                                                                  QuestionType.Dropdown,
                                                                                  QuestionType.TextboxRecommend,
                                                                                  QuestionType.TextboxRecommendMultiChoice,
                                                                                  QuestionType.SliderScale,
                                                                                  // QuestionType.Date,
                                                                              ].includes(
                                                                                  question.question_type as QuestionType
                                                                              ) && (
                                                                                  <>
                                                                                      {shouldShowGraph(
                                                                                          tabActive,
                                                                                          dataDisplay
                                                                                      ) && (
                                                                                          <QuestionRadarChart
                                                                                              showLabel={
                                                                                                  dataDisplay.displayType.includes(
                                                                                                      DisplayType.DATA_IN_GRAPH
                                                                                                  ) ||
                                                                                                  tabActive ===
                                                                                                      'filter'
                                                                                              }
                                                                                              total={
                                                                                                  question.total
                                                                                              }
                                                                                              data={
                                                                                                  question
                                                                                                      ?.data
                                                                                                      ?.rada_chart ??
                                                                                                  []
                                                                                              }
                                                                                          />
                                                                                      )}
                                                                                  </>
                                                                              )
                                                                            : null}

                                                                        <Box
                                                                            mt={
                                                                                1
                                                                            }
                                                                        >
                                                                            {![
                                                                                'textbox',
                                                                                'number',
                                                                                'date',
                                                                            ].includes(
                                                                                question.question_type
                                                                            ) &&
                                                                                shouldShowTableData(
                                                                                    tabActive,
                                                                                    dataDisplay
                                                                                ) && (
                                                                                    <TableDataAnalytics
                                                                                        tables={{
                                                                                            data:
                                                                                                question
                                                                                                    ?.data
                                                                                                    ?.chart_number
                                                                                                    ?.data ??
                                                                                                [],
                                                                                            total: question.total,
                                                                                        }}
                                                                                    />
                                                                                )}

                                                                            {tabActive ===
                                                                                'display' &&
                                                                                [
                                                                                    'textbox',
                                                                                    'number',
                                                                                    'date',
                                                                                ].includes(
                                                                                    question.question_type
                                                                                ) && (
                                                                                    <QuestionTableDetail
                                                                                        questionId={String(
                                                                                            question.question_id
                                                                                        )}
                                                                                    />
                                                                                )}
                                                                            {tabActive ===
                                                                                'filter' &&
                                                                                [
                                                                                    'number',
                                                                                    'textbox',
                                                                                    'date',
                                                                                ].includes(
                                                                                    question.question_type
                                                                                ) &&
                                                                                shouldShowTableData(
                                                                                    tabActive,
                                                                                    dataDisplay
                                                                                ) && (
                                                                                    <QuestionTextFilterResult
                                                                                        params={{
                                                                                            questionId:
                                                                                                question.question_id,
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                        </Box>
                                                                    </Box>
                                                                </>
                                                            )}
                                                        </Box>
                                                    );
                                                }
                                            )}
                                        </Box>
                                    </>
                                )}
                            </>
                        )}
                        {tabActive === 'compare' && (
                            <CompareResult tabActive={tabActive} />
                        )}
                    </Box>
                </Grid>
            </Grid>
            <ModalExportExcelTurbulation
                open={openModalExportExcelTurbulation}
                onClose={() => setOpenModalExportExcelTurbulation(false)}
            />
        </Box>
    );
};
const styles = createStyleSheet({
    tab: {
        minWidth: '40px',
        width: '40px',
        minHeight: '40px',
        height: '40px',
        padding: '0px',
        backgroundColor: '#0000000D',
        borderRadius: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default Summary;
